import React, {useEffect, useMemo, useRef, useState} from "react";
import Card from "components/card";

import {
    createColumnHelper, flexRender, getCoreRowModel, getPaginationRowModel, getSortedRowModel, useReactTable,
} from "@tanstack/react-table";
import {Link, useNavigate} from "react-router-dom";
import {Fab} from "react-tiny-fab";
import {IoCloseSharp} from "react-icons/io5";
import {useSelector} from "react-redux";
import {clearFilters} from "../../../../variables/utils";
import {APIURL} from "../../../../variables/constants";
import Widget from "../../../../components/widget/Widget";
import {GrProjects} from "react-icons/gr";
import axios from "axios";
import {populateAllNLP} from "../../../../actions";
import {RiSearchEyeLine} from "react-icons/ri";
import {BiSolidBot} from "react-icons/bi";
import {IoMdTrendingUp} from "react-icons/io";
import {CiBoxList} from "react-icons/ci";
import {HiCursorClick} from "react-icons/hi";

const columnHelper = createColumnHelper();



export default function NLPLogs({tableData, viewMore = false, nbrows = 100}) {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [allData, setAllData] = useState(tableData);
    const [statsData, setStatsData] = useState(null);
    const inputRef = useRef();
    let allfilters = useSelector(state => state.filters)
    let perday = useSelector(state => state.perday)
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(nbrows);
    const [remoteData, setRemoteData] = useState([]);
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

    // const [pagination, setPagination] = React.useState({
    //     pageIndex: 0, pageSize: nbrows,
    // })
    //
    // const filteredData = useMemo(() => {
    //     return allData.filter(row => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    // }, [allData, searchQuery]);


    const columns = [columnHelper.accessor("searchQuery", {
        id: "searchQuery",
        header: () => (<p className="text-sm font-bold text-gray-600 dark:text-white">Search Query</p>),
        cell: (info) => (<p className="text-sm font-bold text-navy-700 dark:text-white">
            <Link to={'/nlp/' + info.row.original.id}>{info.getValue()}</Link>
        </p>),
    }), columnHelper.accessor("queryDate", {
        id: "queryDate",
        header: () => (<p className="text-sm font-bold text-gray-600 dark:text-white">Date</p>),
        cell: (info) => (<p className="text-sm font-bold text-navy-700 dark:text-white">
            <Link to={'/nlp/' + info.row.original.id}>{info.getValue()}</Link>
        </p>),
    }), columnHelper.accessor("resultType", {
        id: "resultType",
        header: () => (<p className="text-sm font-bold text-gray-600 dark:text-white">Query Type</p>),
        cell: (info) => (<p className="text-sm font-bold text-navy-700 dark:text-white">
            <Link to={'/nlp/' + info.row.original.id}>{info.getValue()}</Link>
        </p>),
    }), columnHelper.accessor("results", {
        id: "results",
        header: () => (<p className="text-sm font-bold text-gray-600 dark:text-white">Results Count</p>),
        cell: (info) => (<p className="text-sm font-bold text-navy-700 dark:text-white">
            <Link to={'/nlp/' + info.row.original.id}>{info.getValue()}</Link>
        </p>),
    }), columnHelper.accessor("status", {
        id: "status",
        header: () => (<p className="text-sm font-bold text-gray-600 dark:text-white">Status</p>),
        cell: (info) => (<p className="text-sm font-bold text-navy-700 dark:text-white">
            <Link to={'/nlp/' + info.row.original.id}>{info.getValue()}</Link>
        </p>),
    })]; // eslint-disable-next-line


    const table = useReactTable({
        data: remoteData, columns, pageCount: -1, manualPagination: true, state: {
            pagination: {
                pageIndex, pageSize
            }
        }, onPaginationChange: (updater) => {
            const next = typeof updater === 'function' ? updater({pageIndex, pageSize}) : updater;
            // console.log(next);
            setPageIndex(next.pageIndex);
            setPageSize(table.getState().pagination.pageSize);
        }, getCoreRowModel: getCoreRowModel(),
    });


    useEffect(() => {
        const handler = setTimeout(() => setDebouncedSearch(searchQuery), 300);
        return () => clearTimeout(handler);
    }, [searchQuery]);


    useEffect(() => {
        axios.get(`${APIURL}?query=dashboardStats`)
            .then(response => {
                setStatsData(response.data);
            });
    }, []);


    useEffect(() => {

        window.addEventListener("keydown", function (e) {
            if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
                if (inputRef.current) {
                    e.preventDefault();
                    inputRef.current.focus();
                }
            }
        })
    }, [inputRef])


    useEffect(() => {
        const fetchData = async () => {
            const url = new URL(APIURL);
            url.searchParams.append("query", "all");
            url.searchParams.append("platform", "nlpStaging");
            url.searchParams.append("offset", pageIndex * pageSize);
            url.searchParams.append("limit", pageSize);
            if (debouncedSearch.trim()) {
                url.searchParams.append("search", debouncedSearch.trim());
            }

            const res = await fetch(url.toString());
            const data = await res.json();
            setRemoteData(data);
            // console.log("data", data);
            populateAllNLP(data);
        };
        fetchData();
    }, [pageIndex, pageSize, debouncedSearch]);


    return (<div className={"w-full h-full px-6 pb-6 sm:overflow-x-auto"}>
        

        <div className="mt-3 mb-4 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
            <Widget
                icon={<RiSearchEyeLine className="h-7 w-7"/>}
                title={"Searches"}
                subtitle={statsData ? statsData.total_searches : 0}
            />


            <Widget
                icon={<BiSolidBot className="h-7 w-7"/>}
                title={"AVG LLM rating"}
                subtitle={statsData ? statsData.avg_llm_rating : 0}
            />


            <Widget
                icon={<IoMdTrendingUp className="h-7 w-7"/>}
                title={"Success Rate"}
                subtitle={statsData ? statsData.success_rate : 0}
            />

            <Widget
                icon={<CiBoxList className="h-7 w-7"/>}
                title={"AVG Results per Query"}
                subtitle={statsData ? statsData.avg_results : 0}
            />

            <Widget
                icon={<HiCursorClick className="h-7 w-7"/>}
                title={"Clicks per Query"}
                subtitle={statsData ? statsData.avg_clicks : 0}
            />







        </div>


        <Card extra={"w-full h-full px-6 pb-6 sm:overflow-x-auto"}>


            {allfilters.length > 0 && <Fab
                mainButtonStyles={{backgroundColor: '#007bff'}}
                position={{bottom: 24, right: 24}}
                icon={<IoCloseSharp title={"Reset Filters"}/>}
                event='click'
                onClick={() => clearFilters(perday)}
            >

            </Fab>}

            {viewMore && <div className="relative flex items-center justify-between pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Chats History
                </div>

                <button
                    onClick={() => {
                        navigate("/all-chats");
                    }}
                    className="!linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
                    <div className="text-sm text-navy-700 dark:text-white">
                        View All
                    </div>
                </button>
            </div>}

            <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
                <div className="pagination-controls flex justify-between items-center w-full space-x-4">
                    <button
                        onClick={() => table.previousPage()}
                        disabled={!table.getCanPreviousPage()}
                        className="px-4 py-2"
                    >
                        Previous
                    </button>

                    <span className="flex-1 text-center">
        Page{" "}
                        <strong>
            {table.getState().pagination.pageIndex + 1}
        </strong>
    </span>

                    <button
                        onClick={() => table.nextPage()}
                        disabled={remoteData.length < pageSize}
                        className="px-4 py-2"
                    >
                        Next
                    </button>

                    <span className="flex items-center">
        | Go to page:{" "}
                        <input
                            type="number"
                            value={table.getState().pagination.pageIndex + 1}
                            onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                table.setPageIndex(page);
                            }}
                            className="ml-2 border rounded w-16 text-center"
                        />
    </span>

                    <select
                        value={table.getState().pagination.pageSize}
                        onChange={(e) => {
                            table.setPageSize(Number(e.target.value));
                        }}
                        className="border rounded px-2 py-1"
                    >
                        {[25, 50, 100].map((pageSize) => (<option key={pageSize} value={pageSize}>
                            Show {pageSize}
                        </option>))}
                    </select>
                </div>


                <div className={"p-2"}>
                    <input
                        className={"w-full p-3 bg-gray-50 rounded-lg"}
                        ref={el => inputRef.current = el}
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                    />
                </div>

                <table className="w-full">
                    <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id} className="!border-px !border-gray-400">
                            {headerGroup.headers.map((header) => {
                                return (<th
                                    key={header.id}
                                    colSpan={header.colSpan}
                                    onClick={header.column.getToggleSortingHandler()}
                                    className="cursor-pointer border-b-[1px] border-gray-200 pt-4 pb-2 pr-4 text-start"
                                >
                                    <div className="items-center justify-between text-xs text-gray-200">
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                        {{
                                            asc: "", desc: "",
                                        }[header.column.getIsSorted()] ?? null}
                                    </div>
                                </th>);
                            })}
                        </tr>))}
                    </thead>
                    <tbody>
                    {table
                        .getRowModel()
                        .rows
                        .map((row) => {
                            return (<tr key={row.id}>
                                {row.getVisibleCells().map((cell) => {
                                    return (<td
                                        key={cell.id}
                                        className="min-w-[150px] border-white/0 py-3  pr-4"
                                    >
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>);
                                })}
                            </tr>);
                        })}
                    </tbody>
                </table>
            </div>


            <div className="pagination-controls flex justify-between items-center w-full space-x-4">
                <button
                    onClick={() => table.previousPage()}
                    disabled={pageIndex === 0}
                    className="px-4 py-2"
                >
                    Previous
                </button>

                <span className="flex-1 text-center">
        Page{" "}
                    <strong>
            {table.getState().pagination.pageIndex + 1}
        </strong>
    </span>

                <button
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                    className="px-4 py-2"
                >
                    Next
                </button>

                <span className="flex items-center">
        | Go to page:{" "}
                    <input
                        type="number"
                        value={table.getState().pagination.pageIndex + 1}
                        onChange={(e) => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0;
                            table.setPageIndex(page);
                        }}
                        className="ml-2 border rounded w-16 text-center"
                    />
    </span>

                <select
                    value={table.getState().pagination.pageSize}
                    onChange={(e) => {
                        table.setPageSize(Number(e.target.value));
                    }}
                    className="border rounded px-2 py-1"
                >
                    {[25, 50, 100].map((pageSize) => (<option key={pageSize} value={pageSize}>
                        Show {pageSize}
                    </option>))}
                </select>
            </div>
        </Card>

    </div>);
}
